import React from 'react';
import ReactEcharts from 'echarts-for-react';

const DynamicGauge = ({ value = 0, color, max }) => {
  const option = {
    series: [
      {
        type: 'gauge',
        radius: "100%",
        center: ['50%', '50%'],
        startAngle: 200,
        endAngle: -200,
        min: 0,
        max: max,
        splitNumber: 12,
        itemStyle: {
          color: color,
        },
        progress: {
          show: true,
          width: 20,
        },
        pointer: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        splitLine: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        anchor: {
          show: false,
        },
        title: {
          show: false,
        },
        detail: {
          valueAnimation: true,
          lineHeight: 30,
          borderRadius: 8,
          offsetCenter: [-135, 38],
          show: false,
        },
        data: [
          {
            value: value,
          },
        ],
      },
    ],
  };

  return <ReactEcharts option={option} style={{ height: '100%', width: '100%' }} />;
};

export default DynamicGauge;
